export const styles = {
  APIwrapper: {
    backgroundColor: '#F9F9FF',
    height: 'calc(100vh - 72px)',
    padding: '32px 35px 20px 40px',
    fontFamily: "'Proxima Nova', sans-serif !important",
  },
  container: {
    display: 'flex',
    flexDirection: 'column',
    justifyContent: 'space-between',
  },
  back: {
    display: 'flex',
    alignItems: 'center',
    fontSize: '16px',
    fontWeight: 700,
    color: '#4F5B94',
    cursor: 'pointer',
    gap: '10px',
  },
  title: {
    fontFamily: "'Proxima Nova', sans-serif",
    color: '#011533',
    fontSize: '32px',
    fontWeight: '700',
  },
  description: {
    fontFamily: "'Proxima Nova', sans-serif",
    fontSize: 16,
    width: '100%',
    maxWidth: '642px',
    fontWeight: 400,
    color: '#000',
  },
  footer: {
    fontFamily: "'Proxima Nova', sans-serif",
    height: 50,
    fontSize: 14,
  },
  linkButton: {
    fontWeight: 600,
    textDecoration: 'underline',
    color: 'black',
    '&:hover': {
      cursor: 'pointer',
    },
  },
  tableTitle: {
    fontWeight: 700,
    color: '#011533',
    fontSize: 18,
    fontFamily: "'Proxima Nova', sans-serif",
    margin: '32px 0 16px 0',
  },
}
